var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxShieldSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2024",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0903 0H0V15.0903H15.0903V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54496 14.3041C6.83445 14.3041 6.15539 14.0966 5.64609 13.7131L2.94241 11.6947C2.22562 11.1603 1.66602 10.0474 1.66602 9.15454V4.4765C1.66602 3.50821 2.37652 2.47703 3.28823 2.1375L6.42576 0.961713C7.04823 0.729071 8.02911 0.729071 8.65158 0.961713L11.7954 2.1375C12.7071 2.47703 13.4176 3.50821 13.4176 4.4765V6.63319C13.4176 6.89099 13.2038 7.10477 12.946 7.10477C12.6882 7.10477 12.4745 6.89099 12.4745 6.63319V4.4765C12.4745 3.90433 12.0029 3.22526 11.4622 3.01777L8.32463 1.84198C7.90964 1.68479 7.17399 1.68479 6.759 1.84198L3.62147 3.02406C3.08073 3.22526 2.60916 3.90433 2.60916 4.48279V9.15454C2.60916 9.75186 3.03043 10.5881 3.50201 10.9402L6.20569 12.9586C6.55151 13.2164 7.03566 13.361 7.53867 13.361C7.79646 13.361 8.01024 13.5747 8.01024 13.8325C8.01024 14.0903 7.80275 14.3041 7.54496 14.3041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0599 13.0469C8.41251 13.0469 7.07324 11.7076 7.07324 10.0602C7.07324 8.41288 8.41251 7.07361 10.0599 7.07361C11.7072 7.07361 13.0465 8.41288 13.0465 10.0602C13.0465 11.7076 11.7072 13.0469 10.0599 13.0469ZM10.0599 8.02304C8.93438 8.02304 8.01639 8.94104 8.01639 10.0665C8.01639 11.192 8.93438 12.11 10.0599 12.11C11.1854 12.11 12.1034 11.192 12.1034 10.0665C12.1034 8.94104 11.1854 8.02304 10.0599 8.02304Z",
    fill: "url(#paint0_linear_18_2024)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2037 13.8323C13.1597 13.8323 13.122 13.826 13.0779 13.8197C13.0402 13.8135 13.0025 13.8009 12.9648 13.782C12.927 13.7694 12.8893 13.7506 12.8516 13.7254C12.8201 13.7003 12.7887 13.6751 12.7573 13.65C12.6441 13.5305 12.5749 13.367 12.5749 13.2036C12.5749 13.1218 12.5938 13.0401 12.6252 12.9646C12.6567 12.8892 12.7007 12.82 12.7573 12.7571C12.9899 12.5245 13.4175 12.5245 13.6501 12.7571C13.7067 12.82 13.7507 12.8892 13.7822 12.9646C13.8136 13.0401 13.8325 13.1218 13.8325 13.2036C13.8325 13.367 13.7633 13.5305 13.6501 13.65C13.5306 13.7632 13.3672 13.8323 13.2037 13.8323Z",
    fill: "url(#paint1_linear_18_2024)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2024",
    x1: 7.74227,
    y1: 7.07361,
    x2: 13.1634,
    y2: 13.8323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2024",
    x1: 7.74227,
    y1: 7.07361,
    x2: 13.1634,
    y2: 13.8323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6D4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0903,
    height: 15.0903,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxShieldSearch);
export default __webpack_public_path__ + "static/media/iconsax-shield-search.b07b3c176f4817164c3d13e84d3c7954.svg";
export { ForwardRef as ReactComponent };